import React from 'react'

import {
    RegisterOptions,
    DeepMap,
    FieldError,
    UseFormRegister,
    Path,
} from 'react-hook-form'
import Input, { InputNumber, InputProps } from '../../ui/FormElememts/Input'
import { TextArea, TextAreaProps } from '../../ui/FormElememts/TextArea'
import {
    Select,
    ISelectOptions,
    SelectProps3,
} from '../../ui/FormElememts/Select'

export type FormInputProps<TFormValues> = {
    name: Path<TFormValues>
    rules?: RegisterOptions
    register?: UseFormRegister<TFormValues>
    errors?: Partial<DeepMap<TFormValues, FieldError>>
} & Omit<InputProps, 'name'>

export type FormSelectProps<TFormValues> = {
    name: Path<TFormValues>
    rules?: RegisterOptions
    register?: UseFormRegister<TFormValues>
    errors?: Partial<DeepMap<TFormValues, FieldError>>
} & Omit<SelectProps3, 'name'>

export type FormTextAreaProps<TFormValues> = {
    name: Path<TFormValues>
    rules?: RegisterOptions
    register?: UseFormRegister<TFormValues>
    errors?: Partial<DeepMap<TFormValues, FieldError>>
} & Omit<TextAreaProps, 'name'>

export const FormInput = <TFormValues extends Record<string, unknown>>({
    name,
    register,
    rules,
    ...props
}: FormInputProps<TFormValues>): JSX.Element => {
    return (
        <Input
            name={name}
            {...props}
            {...(register && register(name, rules))}
        />
    )
}

export const FormSelect = <TFormValues extends Record<string, unknown>>({
    name,
    register,
    rules,
    ...props
}: FormSelectProps<TFormValues>): JSX.Element => {
    return (
        <Select
            name={name}
            {...props}
            {...(register && register(name, rules))}
        />
    )
}

export const FormInputNumber = <TFormValues extends Record<string, unknown>>({
    name,
    register,
    rules,
    ...props
}: FormInputProps<TFormValues>): JSX.Element => {
    return (
        <InputNumber
            name={name}
            {...props}
            {...(register && register(name, rules))}
        />
    )
}

export const FormTextArea = <TFormValues extends Record<string, unknown>>({
    name,
    register,
    rules,
    ...props
}: FormTextAreaProps<TFormValues>): JSX.Element => {
    return (
        <TextArea
            name={name}
            {...props}
            {...(register && register(name, rules))}
        />
    )
}
